export type RecipeCategory = "breakfast" | "lunch" | "dinner" | "dessert" | "snack" | "drink" | "other";

export const RECIPE_CATEGORIES: RecipeCategory[] = [
  "breakfast", "lunch", "dinner", "dessert", "snack", "drink", "other",
];

export type Recipe = {
  id: string;
  userId: string;
  title: string;
  description?: string;
  ingredients: string[];       // list of ingredient strings
  steps: string[];             // ordered preparation steps
  category?: RecipeCategory;
  cookTime?: number;           // minutes
  prepTime?: number;           // minutes
  servings?: number;
  imageUrl?: string;           // photo of the dish
  rating?: number;             // 1-5 stars
  notes?: string;              // personal notes
  cooked?: boolean;            // has the user made this
  cookedCount?: number;        // how many times cooked
  lastCooked?: string;         // ISO date
  dateAdded: string;           // ISO date
  favourite?: boolean;
};
